export default function ClientMedia() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Media Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
